<template>
  <mdb-navbar
    class="flexible-navbar white mt-0"
    v-bind:style="{fontFamily: 'OpenSans-Regular', fontSize: '10px'}"
    position="top"
    double
    scrolling
  >
    <mdb-navbar-brand @click.native="toggleSideNav" class="button-collapse">
      <mdb-icon icon="bars" />
    </mdb-navbar-brand>

    <mdb-navbar-nav class="right-nav" right>
      <mdb-nav-item v-if="whoami">
        <img
          alt="logo fraccionamiento"
          v-if="whoami.logoURL"
          :src="whoami.logoURL"
          style="display: inline-block;"
          class="previewLogo"
        />
      </mdb-nav-item>
      <mdb-dropdown class="nav-item" tag="li">
        <mdb-dropdown-toggle slot="toggle" tag="li" outline="none" class="btn-transparent">
          <span
            class="clearfix d-none d-sm-inline-block"
            style="margin-top: 5%; font-size: 14px; font-family: OpenSans-Bold;"
          >{{activeFrac}}</span>
          <br />
          <span
            class="clearfix d-none d-sm-inline-block"
            style="margin-top: 5%; font-size: 10px; font-family: OpenSans-Regular;"
          >{{whoami.username}}</span>
        </mdb-dropdown-toggle>
        <mdb-dropdown-menu color="ins" right>
          <mdb-dropdown-item v-show="false" :href="serverWebSite">Volver</mdb-dropdown-item>
          <div v-show="flag" v-for="(item, index) in fracsList" :key="index">
            <mdb-dropdown-item @click="changeFrac(item.uuid)" href="../">{{item.name}}</mdb-dropdown-item>
          </div>
          <mdb-dropdown-item @click="logout()" href="../">Cerrar Sesión</mdb-dropdown-item>
        </mdb-dropdown-menu>
      </mdb-dropdown>
      <mdb-nav-item>
        <div class="circuloPerfil">
          <div class="LetrasContenedor">
            <span class="Nombre">{{userData[0]}}</span>
            <span class="Apellido">{{userData[1]}}</span>
          </div>
        </div>
      </mdb-nav-item>
    </mdb-navbar-nav>
  </mdb-navbar>
</template>

<script>
/* eslint-disable */
import Axios from "axios";
import Servers from "../../server.js";
import { mapGetters, mapActions } from "vuex";
import {
  mdbNavbar,
  mdbNavbarBrand,
  mdbNavItem,
  mdbNavbarNav,
  mdbNavbarToggler,
  mdbBreadcrumb,
  mdbDropdown,
  mdbDropdownToggle,
  mdbDropdownMenu,
  mdbDropdownItem,
  mdbIcon,
  mdbBadge
} from "mdbvue";

export default {
  name: "Navbar",
  props: {
    page: {
      type: String
    }
  },
  components: {
    mdbNavbar,
    mdbNavbarBrand,
    mdbNavItem,
    mdbNavbarNav,
    mdbNavbarToggler,
    mdbBreadcrumb,
    mdbDropdown,
    mdbDropdownToggle,
    mdbDropdownMenu,
    mdbDropdownItem,
    mdbIcon,
    mdbBadge
  },
  data() {
    return {
      activePage: this.page,
      toggle: false,
      isAdmin: true,
      access_token: "",
      server: "",
      serverWebSite: "",
      whoami: [],
      userData: [],
      fracsList: [],
      activeFrac: "",
      flag: false
    };
  },
  methods: {
    ...mapActions(["logOut", "checkSession"]),
    changeFrac: function(uuid) {
      if (uuid) {
        Axios.put(Servers.serverApi + "api/users/setUpdateFrac/" + uuid,{}, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token")
          }
        }).then(
          function(response) {
            window.location.reload();
          },
          function(error) {
            console.log("error change frac");
          }
        );
      }

      window.location.href = "./#";
    },
    toggleSideNav() {
      this.toggle = !this.toggle;
      this.$parent.$emit("toggle", this.toggle);
    },
    async logout() {
      this.access_token = "";
        this.whoami = [];
         await this.logOut()
      if (this.whoami.role == "Contratista") {
        window.location.href = "../Login?type=contractor";
        //window.location.href = Servers.serverWeb;
      } else {
       //window.location.href = "../";
      //  window.location.href = Servers.serverWeb;
      this.$router.push("/")
      }
    },
    async checkRole() {
      await this.checkSession();
     
      var role = localStorage.getItem("role");
      if (
        role == "Residente" ||
        role === "Contratista" ||
        role === "Capturista" ||
        role === "Integrador" ||
        role === "Administrador general"
      ){
        this.isAdmin = false;
      }
      else{
        this.isAdmin = true;
      }
        this.whoami = this.myfrac;
        this.userData=this.myfrac.username.split(" ");
        this.activeFrac = this.myfrac.frac;
        localStorage.setItem("isAdmin", this.isAdmin);
    }
  },
  watch: {
    whoami(newValue) {
     
      if (this.whoami.myfrac.length > 1) this.flag = true;
      this.fracsList = [];
      
      for (var i = 0; i < this.whoami.myfrac.length; i++) {
        if (this.whoami.myfrac[i].name != this.activeFrac)
          this.fracsList.push(this.whoami.myfrac[i]);
      }
    }
  },
  computed: {
    ...mapGetters({
      myfrac:"getWhoAmi",
      isLogin:"getAuthenticated"
    }),
    computedPage() {
      return {
        activePage: this.page
      };
    }
  },
  created() {
  if(localStorage.getItem("access_token")){
      this.checkRole();
  }
  
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar .nav-item {
  line-height: 24px;
  font-size: 16px;
}
.navbar .dropdown-toggle {
  padding: 0 10px;
  font-size: 16px;
}

.navbar ul {
  padding: 5px 0;
}

.navbar .btn {
  font-weight: 300;
}

.navbar-collapse {
  order: 0 !important;
}

.navbar .notifications-nav .dropdown-menu {
  width: 23rem;
}

.navbar-expand-lg .navbar-nav {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  flex-direction: row;
}

.btn-transparent {
  background-color: transparent !important;
  color: #000;
  text-transform: none;
  box-shadow: none !important;
}

.btn-transparent:hover,
.btn-transparent:active {
  box-shadow: none !important;
}

.previewLogo {
  max-height: 50px;
}
</style>
<style>
.circuloPerfil {
  width: 40px;
  height: 40px;
  background-color: #23a7ed;
  border-radius: 50%;
  margin: 0 auto;
  position: relative;
  margin-bottom: 10px;
}

.circuloPerfil > .LetrasContenedor {
  width: 20px;
  height: auto;
  color: #ffffff;
  font-family: "OpenSans-Regular";
  font-size: 10px;
  text-transform: uppercase;
  text-align: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
}

.circuloPerfil > .LetrasContenedor > .Nombre {
  width: 10px;
  float: left;
  display: block;
  visibility: hidden;
}

.circuloPerfil > .LetrasContenedor > .Nombre:first-letter {
  visibility: visible;
}

.circuloPerfil > .LetrasContenedor > .Apellido {
  width: 10px;
  float: left;
  display: block;
  visibility: hidden;
}

.circuloPerfil > .LetrasContenedor > .Apellido:first-letter {
  visibility: visible;
}
</style>
